import { useQuery } from '@tanstack/react-query'
import { whatsappService } from '@/services/whatsappService'
import { queryKeys } from '../keys'

interface UseWhatsAppStatusQueryOptions {
  enabled?: boolean
}

export function useWhatsAppStatusQuery(options: UseWhatsAppStatusQueryOptions = {}) {
  return useQuery({
    queryKey: queryKeys.meta.whatsappStatus(),
    queryFn: async () => whatsappService.getStatus(),
    enabled: options.enabled ?? true,
  })
}